/**
 * Init FAQ slider.
 */
const $sliderPrevArrow = `${'.section-faq'} .slider__prev`;
const $sliderNextArrow = `${'.section-faq'} .slider__next`;

const faqSlider = function() {
  const $slider = $('.js-faq-slider');

  if ( ! $slider.length ) {
    return;
  }

  $slider.slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    dots: false,
    infinite: true,
    autoplay: false,
    autoplaySpeed: 3000,
    speed: 500,
    fade: true,
    cssEase: 'linear',
    pauseOnFocus: false,
    pauseOnHover: false,
    adaptiveHeight: true,
    prevArrow: $sliderPrevArrow,
    nextArrow: $sliderNextArrow
  })
};

faqSlider();

$(window).on('shopify:section:load', function(event) {
  faqSlider();
});
